import { render, staticRenderFns } from "./CalendarChildVisitation.vue?vue&type=template&id=647443a7"
import script from "./CalendarChildVisitation.vue?vue&type=script&lang=js"
export * from "./CalendarChildVisitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports